import { render, staticRenderFns } from "./project-tracker-dashboard.vue?vue&type=template&id=085ecb0a&scoped=true&"
import script from "./project-tracker-dashboard.vue?vue&type=script&lang=js&"
export * from "./project-tracker-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./project-tracker-dashboard.vue?vue&type=style&index=0&id=085ecb0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085ecb0a",
  null
  
)

export default component.exports